import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import ConditionWarningBanner from '../ConditionWarningBanner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DisplayMissingAssociationBranchFilter = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "customerDataFilters.FilterMissingAssociationBranch.filterLabel"
    }), /*#__PURE__*/_jsx(ConditionWarningBanner, {
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.FilterMissingAssociationBranch.warning"
        })
      })
    })]
  });
};
DisplayMissingAssociationBranchFilter.propTypes = {};
export default DisplayMissingAssociationBranchFilter;